<template>
  <header class="header">
    <app-creation-modal :data-activator-text="$t('message.admPartners.message.registerPartner')"
                        data-entity="partners"></app-creation-modal>

    <div class="search-wrapper">
      <app-search-bar v-model="search"
                      @enter="emitLoadData"></app-search-bar>
    </div>
  </header>
</template>

<script>
import AppSearchBar from "@components/Search";
import AppCreationModal from "@components/user-modal/UserModal";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppSearchBar,
    AppCreationModal,
  },

  data() {
    return {
      search: undefined,
    };
  },

  computed: {},

  methods: {
    emitLoadData() {
      EventBus.$emit("LOAD_DATA", this.search);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */

  .search-wrapper {
    margin-left: auto;
    margin-right: 50px;
  }
}
</style>
